<div class="white-background">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div class="p-4">
            <img class="" ngSrc="/assets/img/logo.png" alt="LOGO" width="340" height="68" />
        </div>

        <div class="tagline">
            <h5 class="text-weight-bold" style="color: #3BA378">
                World’s Most Reliable Certification Manager for
                <i>Competitive</i> Professionals
            </h5>
        </div>
    </div>
    <div class="text-center">
        <img class="mt-2 mb-5" ngSrc="/assets/img/Welcome-to-Your-New-Wallet!.png" alt="" width="374" height="89" />
    </div>
    <div class="container white-background">
        <mat-card class="shadow-lg card-form">
            <mat-card-content class="rounded-lg text-center">
                <h3 class="mb-4" style="font-weight: bold;">Reset Password</h3>
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Email Address</mat-label>
                                <input type="text" matInput formControlName="email" >
                                <mat-icon matPrefix>mail</mat-icon>
                                <mat-error *ngIf="submitted && f['email'].invalid && f['email'].errors['required']">Email is required</mat-error>
                                <mat-error *ngIf="submitted && f['email'].invalid && f['email'].errors?.['email']">Email must be a valid email address</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-12 text-start">
                            <mat-form-field appearance="outline" class="w-100 password">
                                <mat-label>New Password</mat-label>
                                <input [type]="typePassword ? 'password' : 'text'" matInput formControlName="password"  pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}">
                                <mat-icon matPrefix>key</mat-icon>
                                <mat-icon color="primary" matSuffix *ngIf="form.controls['password'].value != '' && form.controls['password'].value == form.controls['confirmPassword'].value">check</mat-icon>
                                <!-- Show Password Suggestion -->
                                <mat-icon [matTooltip]="'Suggest strong password'" matSuffix (click)="showPasswordSuggestion($event)" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="passwordMenu"
                                          style="cursor: pointer;">lock_reset</mat-icon>

                                <!-- Toggle Password Visibility -->
                                <mat-icon [matTooltip]="typePassword ? 'Show Password' : 'Hide Password'" matSuffix style="cursor: pointer;" (click)="typePassword = !typePassword">
                                    {{ typePassword ? 'visibility' : 'visibility_off' }}
                                </mat-icon>
                            </mat-form-field>

                            <!-- Password Suggestion Menu -->
                            <mat-menu #passwordMenu="matMenu" [overlapTrigger]="false" yPosition="below">
                                <div class="p-3">
                                    <div class="mb-2">Suggested Strong Password</div>
                                    <div class="password-container">
                                        <span>{{ suggestedPassword }}</span>
                                        <mat-icon class="copy-icon" (click)="copyPassword()">content_copy</mat-icon>
                                    </div>

                                </div>
                            </mat-menu>

                            <!-- Password Strength Indicator -->
                            <div class="strength-bar" *ngIf="form.controls['password'].value.length > 0">
                                <div [class]="strengthClass">&nbsp;</div>
                            </div>

                            <mat-error *ngIf="form.controls['password'].errors && submitted && f['password'].errors['pattern']">
                                Password must contain number, uppercase, lowercase letter and special character.
                            </mat-error>
                            <mat-error *ngIf="form.controls['password'].errors && submitted && f['password'].errors['minLength']">Password must be at least 8 characters</mat-error>
                        </div>
                    </div>

                    <div class="row mt-5">
                        <div class="col-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Confirm New Password</mat-label>
                                <input [type]="typePassword ? 'password' : 'text'" matInput formControlName="confirmPassword"  pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}">
                                <mat-icon matPrefix>key</mat-icon>
                                <mat-icon color="primary" matSuffix *ngIf="form.controls['password'].value != '' && form.controls['password'].value == form.controls['confirmPassword'].value">check</mat-icon>
                                <mat-error *ngIf="form.controls['password'].errors && submitted && form.controls['password'].errors['required']">Password is required</mat-error>
                                <mat-error *ngIf="form.controls['password'].errors && submitted && f['password'].errors['pattern']">
                                    Password must contain number, uppercase, lowercase letter and special character.
                                </mat-error>
                                <mat-error *ngIf="form.controls['password'].errors && submitted && f['password'].errors['minLength']">Password must be at least 8 characters</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-group mt-4">
                        <div class="d-flex justify-content-center mt-2">
                            <button style="margin-right: 10px;"
                                    (click)="onSubmit()"
                                    mat-raised-button
                                    class="mt-2 form-button">
                                <mat-icon>shield</mat-icon>Reset Password
                            </button>
                            <button
                                    mat-raised-button
                                    class="mt-2 form-button"
                                    type="button"
                                    [routerLink]="'/login'">
                                <mat-icon>chevron_right</mat-icon>Cancel
                            </button>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>

